export const LETTER_SELECT_LANGUAGE = 'LETTER_SELECT_LANGUAGE';
export const LETTER_SELECT_TEMPLATE = 'LETTER_SELECT_TEMPLATE';
export const LETTER_SELECT_CUSTOM_TEMPLATE = 'LETTER_SELECT_CUSTOM_TEMPLATE';
export const LETTER_SELECT_CATEGORY = 'LETTER_SELECT_CATEGORY';
export const LETTER_SELECT_IS_CUSTOM = 'LETTER_SELECT_IS_CUSTOM';

export const LETTER_TEMPLATES_FETCHING = 'LETTER_TEMPLATES_FETCHING';
export const LETTER_TEMPLATES_FETCH = 'LETTER_TEMPLATES_FETCH';
export const LETTER_TEMPLATES_FETCH_ERROR = 'LETTER_TEMPLATES_FETCH_ERROR';

export const LETTER_CUSTOM_TEMPLATES_FETCHING =
  'LETTER_CUSTOM_TEMPLATES_FETCHING';
export const LETTER_CUSTOM_TEMPLATES_FETCH = 'LETTER_CUSTOM_TEMPLATES_FETCH';
export const LETTER_CUSTOM_TEMPLATES_FETCH_ERROR =
  'LETTER_CUSTOM_TEMPLATES_FETCH_ERROR';

export const LETTER_CUSTOM_TEMPLATE_FETCHING =
  'LETTER_CUSTOM_TEMPLATE_FETCHING';
export const LETTER_CUSTOM_TEMPLATE_FETCH = 'LETTER_CUSTOM_TEMPLATE_FETCH';
export const LETTER_CUSTOM_TEMPLATE_FETCH_ERROR =
  'LETTER_CUSTOM_TEMPLATE_FETCH_ERROR';

export const LETTER_WRITE_CUSTOM_LETTER_FETCHING =
  'LETTER_WRITE_CUSTOM_LETTER_FETCHING';
export const LETTER_WRITE_CUSTOM_LETTER = 'LETTER_WRITE_CUSTOM_LETTER';
export const LETTER_WRITE_CUSTOM_LETTER_ERROR =
  'LETTER_WRITE_CUSTOM_LETTER_ERROR';

export const LETTER_PREVIEW_FETCHING = 'LETTER_PREVIEW_FETCHING';
export const LETTER_PREVIEW_FETCH = 'LETTER_PREVIEW_FETCH';
export const LETTER_PREVIEW_FETCH_ERROR = 'LETTER_PREVIEW_FETCH_ERROR';
export const LETTER_PREVIEW_CLEAR = 'LETTER_PREVIEW_CLEAR';



// WEBPACK FOOTER //
// ./src/pages/lettersetup/state/setup/types.js